import { Input } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { TableCellEntityMode } from 'entities/TableCell';
import { TableInputStringController } from 'stores/common';

import { TableControllerProps } from '../types';

const InputStringController: React.FC<
  TableControllerProps<TableInputStringController>
> = ({ record, className, params }) => {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      record.setValue(e.currentTarget.value);
    },
    [record]
  );

  const controllerDisabled = params?.mode === TableCellEntityMode.disabled;

  return (
    <Input
      className={className}
      value={record.controllerValue}
      onChange={handleChange}
      disabled={controllerDisabled}
    />
  );
};

export default observer(InputStringController);
